import React, { useMemo, useState } from 'react'
import DOMPurify from 'dompurify'
import { Form } from 'react-bootstrap'
import { Button } from '../Button/Button'
import styles from './CustomWorkflows.module.scss'

export interface HtmlPreviewProps {
  html: string
  title?: string
  onChange?: (value: string) => void
}

export const HtmlPreview: React.FC<HtmlPreviewProps> = ({ html, title, onChange }) => {
  const [showSource, setShowSource] = useState<boolean>(false)

  const sanitized = useMemo(
    () =>
      DOMPurify.sanitize(html, {
        USE_PROFILES: { html: true },
        FORBID_TAGS: ['style', 'script', 'form', 'input', 'button', 'textarea', 'select'],
        FORBID_ATTR: ['style'],
      }),
    [html],
  )

  const showHeader = title !== undefined || onChange !== undefined

  return (
    <div>
      {showHeader ? (
        <div className='d-flex justify-content-between align-items-center mb-2 zocks-gap-2'>
          {title ? <span className='fw-semibold paragraph-small'>{title}</span> : <span />}
          <Button type='button' variant='link' className='p-0 paragraph-small' onClick={() => setShowSource((value) => !value)}>
            {showSource ? 'Show preview' : 'Show source'}
          </Button>
        </div>
      ) : null}
      {showSource ? (
        <Form.Control as='textarea' rows={10} value={html} readOnly={!onChange} onChange={onChange ? (e) => onChange(e.target.value) : undefined} />
      ) : (
        <div className={styles.richText} dangerouslySetInnerHTML={{ __html: sanitized }} />
      )}
    </div>
  )
}

export default HtmlPreview
